"use strict";
/*
 * Created on 24. 1. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Type of price list row change.
 * @author Radek Beran
 */

var PriceListRowChange;

(function (PriceListRowChange) {
  PriceListRowChange["Insert"] = "Insert";
  PriceListRowChange["Update"] = "Update";
  PriceListRowChange["Delete"] = "Delete";
  PriceListRowChange["Skipped"] = "Skipped";
})(PriceListRowChange = exports.PriceListRowChange || (exports.PriceListRowChange = {}));